export default __webpack_public_path__ + "static/email-templates-send-email-button-2ae55bee6d429908c5d76328c866c483.mp4";